<div fxLayout="column" fxLayoutAlign="center center">
  <div
    class="main-container"
    [class.required-error]="showRequiredError"
    (mouseenter)="mouseEnter()"
    (mouseleave)="mouseLeave()"
  >
    <div class="avatar-container">
      <lineup-avatar
        [image]="image"
        [darkened]="shouldShowIcons"
        [thumbnail]="false"
      ></lineup-avatar>
    </div>
    @if (shouldShowUploadPhoto()) {
      <button
        class="icon-container upload"
        [attr.aria-label]="
          required ? 'Upload Photo (required)' : 'Upload Photo'
        "
        [attr.aria-invalid]="showRequiredError ? 'true' : null"
        [attr.aria-describedby]="
          showRequiredError ? 'photo-required-error' : null
        "
        (click)="fileInput.click()"
        (blur)="blurred.emit()"
      >
        <mat-icon class="file-upload">insert_photo</mat-icon><br />
        <span
          ><b
            >Upload<br />Photo
            @if (required) {
              <span class="required">*</span>
            }
          </b></span
        >
      </button>
    }
    @if (shouldShowRemoveIcon()) {
      <button
        mat-mini-fab
        color="warn"
        aria-label="Delete photo"
        class="icon-container delete"
        (click)="removePicture()"
      >
        <mat-icon class="file-remove">delete</mat-icon>
      </button>
    }
  </div>
  @if (showRequiredError) {
    <label id="photo-required-error" class="required-message">{{
      requiredErrorMessage
    }}</label>
  }
  <input
    type="file"
    id="fileupload"
    #fileInput
    ng2FileSelect
    [uploader]="uploader"
    (change)="fileInput.value = ''"
    accept="image/jpeg,image/jpg,image/png,image/x-png"
  />
</div>
